import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material';

import useTopPanel from 'hooks/useTopPanel';
import CRMBlockColumns from './crm-parts/block-columns/CRMBlockColumns';
import CRMTopPanel from './crm-parts/top-panel/CRMTopPanel';
import useMenu from 'hooks/useMenu';
import TableList from './crm-parts/table-list';
import TasklessLeadsModal from './crm-parts/TasklessLeadsModal';

const CRM = () => {
  const { setComponent } = useTopPanel();
  const { t } = useTranslation();
  const { hasChild } = useMenu();
  const [openSettings, setOpenSettings] = useState(false);
  const [showType, setShowType] = useState(
    localStorage.getItem('crm-show-type') || 'column'
  );
  // Yangi ko'rinish (Shartnoma sahifasidagi kabi) — eski dizayn default
  const [modern, setModern] = useState(
    localStorage.getItem('crm-modern-view') === '1'
  );

  const view = (code) => hasChild('CRM', code);

  const handleAlignment = (event, type) => {
    if (type) {
      setShowType(type);
      localStorage.setItem('crm-show-type', type);
    }
  };

  const toggleModern = () => {
    setModern((prev) => {
      localStorage.setItem('crm-modern-view', prev ? '0' : '1');
      return !prev;
    });
  };

  useEffect(() => {
    setComponent(
      <div className='flex items-center gap-4'>
        {t('sidebar.admin.crm')}
        <div className='flex items-center justify-center'>
          <ToggleButtonGroup
            value={showType}
            exclusive
            onChange={handleAlignment}
            className='!shadow-none h-12 !border-none'
          >
            <ToggleButton value='column'>
              <i className='bi bi-layout-three-columns' />
            </ToggleButton>
            <ToggleButton value='sheet'>
              <i className='bi bi-table' />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <Button
          variant='base'
          size='small'
          className='!text-[12px] whitespace-nowrap'
          onClick={toggleModern}
          startIcon={
            <i
              className={`bi ${
                modern ? 'bi-layout-text-sidebar' : 'bi-grid-1x2'
              } text-xs`}
            />
          }
        >
          {modern
            ? t('contract.view.classicView')
            : t('contract.view.modernView')}
        </Button>
      </div>
    );

    return () => setComponent('');
  }, [showType, modern]);

  return (
    <div className='component-list-wrapper rounded-lg'>
      <CRMTopPanel
        addBlock={view('CRM_ADD_BLOCK')}
        addLead={true}
        openSettings={openSettings}
        setOpenSettings={setOpenSettings}
      />
      <div className='crm-wrapper'>
        {showType !== 'sheet' ? (
          <CRMBlockColumns
            openSettings={openSettings}
            setOpenSettings={setOpenSettings}
            modern={modern}
          />
        ) : (
          <TableList />
        )}
      </div>
      <TasklessLeadsModal />
    </div>
  );
};
export default memo(CRM);
